// 测试环境配置
import { isJwInlandApp, isJwIntlApp } from "../utils/app/env";

const deployDir = isJwInlandApp
  ? "/jw-inland-kuaipk/"
  : isJwIntlApp
  ? "/jw-intl-kuaipk/"
  : "/kuaipk/";
const hostname = "http://v5.dev.basejy.com";
const appUrl = isJwInlandApp
  ? `${hostname}/jw-inland-kuaipk`
  : isJwIntlApp
  ? `${hostname}/jw-intl-kuaipk`
  : `${hostname}/kuaipk`;
const JW_APP_URL = isJwInlandApp
  ? `${hostname}/jw-inland`
  : isJwIntlApp
  ? `${hostname}/jw-intl`
  : `${hostname}/jw-inland`;

export default {
  SERVER_URL: "http://ttfs.154basejy.com", // 后端服务域名
  DEPLOY_DIR: deployDir, // 项目部署的目录
  APP_URL: appUrl, // 本项目访问地址
  H5_STATIC_SERVER_URL: "https://tencent.dev-env.basejy.com", // h5页面访问地址
  WX_APPID: "wx99bc4493f44c706f", // 微信公众号appid
  WX_MP_APP_ID: "wxef1aa2457078e512", // 微信小程序appid
  SHOW_MAI_DIAN_LOG: true, // 是否打印埋点日志到浏览器控制台
  ALLOW_MOBILE_LOGIN_PAGE: true, // 是否打开手机登录页面
  JW_APP_URL: JW_APP_URL,
  JW_KUAIPK_APP_URL: `${JW_APP_URL}-kuaipk`,
  JW_KUAIJK_APP_URL: `${JW_APP_URL}-kuaijk`,
  JW_KUAIXK_APP_URL: `${JW_APP_URL}-kuaixk`,
  JW_KUAICJ_APP_URL: `${JW_APP_URL}-kuaicj`,
  // marketing-plugins 基础地址（按你们测试环境实际部署路径修改）
  MARKETING_PLUGINS_APP_URL: `${hostname}/marketing-plugins`,
  // 帮助中心（basejy-help）地址：产品内浮层 iframe 嵌入用
  // 测试环境帮助站部署在智校工作台域名下，弹出帮助站首页（与后端确认）
  HELP_SITE_URL: "http://www.test.school.basejy.com/basejy/help/",
  // 智校工作台主页（倍思教务品牌站），活动入口/应用中心跳转目标
  SCHOOL_WEB_APP_URL: "http://www.test.school.basejy.com",
  KUAI_JW_CONSULTATION_URL: "http://www.test.school.basejy.com/#/basejw/kuaijw-consultation",
  // 快教务版本导购落地页（version-guide），教务版权益升级引导跳转目标
  VERSION_GUIDE_URL: "http://www.test.school.basejy.com/basejy/market/landing-pages/version-guide/",
};
